module.exports = __webpack_public_path__ + "fdbedf62ac0ede8da0c22b86e82f6226.png";